import { observable, action } from 'mobx';
import firebaseService from '../FirebaseService';
import Utils from '../Utils';
import { utimes } from 'fs';

class UserStore {
    @observable CurrentUser;
    @observable LoadingUser = false;
    @observable LoginMessage = "";
    @observable LoadingUsers = false;
    @observable UpdatingUser;
    @observable LoginError;
    @observable Users = [];
    @observable ShowAddUser = false;
    @observable LoadingAddUser = false;
    @observable LoadingUserToUpdate = false;
    @observable SendingResetEmail = false;
    @observable UserIdToReset = "";
    @observable LoginRequest = {
        Email: "",
        Password: ""
    };
    @observable AddUserRequest = {
        FirstName: "",
        LastName: "",
        Email: "",
        UserType: "",
        IsSupportUser: false,
        Ext: null,
        UID: ""
    }
    @action UpdateProperty(key, value) {
        this.LoginRequest[key] = value;
    }
    @action UpdateAddUserProperty(key, value) {
        this.AddUserRequest[key] = value;
    }
    @action IsValid(key) {
        if (key === "Email") {
            var regex = new RegExp('[^@]+@[^@]+\\.[^@]+');
            if (regex.test(this.LoginRequest[key])) {
                return 'success';
            }
            else {
                return 'error';
            }
        }
    }
    @action GetCurrentUserFromCollection() {
        if (Utils.Cookies.Read("uid") !== null) {
            console.log("Is GetCurrentUserFromCollection In "+JSON.stringify(this.CurrentUser));
            this.LoginMessage = "Trying to authenticate using last login, please wait.."
            this.LoadingUser = true;
            firebaseService.User(Utils.Cookies.Read("uid"))
                .then((u) => { this.CurrentUser = u.val();  })
                .catch((err) => { console.log(err); })
                .finally(() => { this.LoadingUser = false; this.LoginMessage = "";  });
               
        }
    }
    @action Logout() {
        this.CurrentUser = undefined;
        firebaseService.Logout();
    }
    @action ShowOrHideAddUserModal(id) {
        if(id !== undefined && id !== null && id !== ""){
            this.LoadingUserToUpdate = true;
            firebaseService.User(id)
                .then((snapshot) => {
                    var user = snapshot.val();
                    Utils.Basic.CopyTo(user, this.AddUserRequest);
                })
                .catch((err) => { console.log(err); Utils.Toast.Error("Unable to retrieve user with Id : " + id); })
                .finally(() => { this.LoadingUserToUpdate = false; })
        }
        this.ShowAddUser = this.ShowAddUser ? false : true;
    }
    @action IsLoggedIn() {
        
        if(this.CurrentUser === undefined){
            return false;
        }
        if (this.CurrentUser.UserType === "Admin") {
            return true;
        }
        else {
            return false;
        }
    }
    @action Login() {
        this.LoadingUser = true;
        this.LoginMessage = "Trying to login, please wait.."
        firebaseService.Login(this.LoginRequest.Email, this.LoginRequest.Password)
            .then((user) => {
                Utils.Cookies.Create("uid", user.uid, 30);
                firebaseService.User(user.uid)
                    .then((snapshot) => {
                        var user = snapshot.val();
                        if (user.UserType === "Admin") {
                            this.CurrentUser = user;
                        }
                        else {
                            this.LoginError = "Only admin users can access this website";
                            this.CurrentUser = null;
                        }
                    })
                    .catch((err) => { console.log(err); Utils.Toast.Error("Unable to login try again with correct credentials."); })
                    .finally(() => { this.LoadingUser = false; this.LoginMessage = ""; })
            })
            .catch(function (error) { console.log(error); })
            .finally(() => { this.LoadingUser = false; })
    }
    @action GetUsers() {
        this.LoadingUsers = true;
        firebaseService.Users()
            .then((snapshot) => {
                this.Users = [];
                snapshot.forEach((childSnapshot) => {
                    this.Users.push(childSnapshot.val());
                })
            })
            .catch((err) => { console.log(err); Utils.Toast.Error("Unable to retrieve users"); })
            .finally(() => { this.LoadingUsers = false; });
    }
    @action AddUser() {
        var user = {};
        Utils.Basic.CopyTo(this.AddUserRequest, user);
        user.CreatedDate = Utils.Dates.ToJsonDate();
        user.ModifiedDate = Utils.Dates.ToJsonDate();
        this.LoadingAddUser = true;
        firebaseService.RegisterUser(user.Email, "AHJA&&S&&S*W*S*W&")
            .then((u) => {
                user.UID = u.uid;
                firebaseService.SendResetPasswordEmail(user.Email)
                    .then(() => {
                        firebaseService.AddUser(user)
                            .then(() => {
                                this.ShowOrHideAddUserModal();
                                this.GetUsers();
                            })
                            .catch((err) => { console.log(err); })
                    })
                    .catch((err) => { console.log(err); })
            })
            .catch((err) => { console.log(err); })
            .finally(() => { this.LoadingAddUser = false; });
    }
    @action ResetPassword(email){
        this.SendingResetEmail = true;
        firebaseService.SendResetPasswordEmail(email)
            .then(()=>{
                Utils.Toast.Success("Password reset email sent to "+email);
            })
            .catch((err)=>{ console.log(err); Utils.Toast.Error("Unable to reset password for user - "+ email); })
            .finally(()=>{this.SendingResetEmail = false;})
    }
    
}
export default new UserStore();



// WEBPACK FOOTER //
// ./src/stores/UserStore.js